import React, { useRef, useEffect } from 'react';

const LessonList = ({
  lessons,
  onSelectLesson,
  onDeleteLesson,
  onAddLesson,
  newLessonTitle,
  setNewLessonTitle,
  getGradient,
}) => {
  const inputRef = useRef(null);

  // Giữ focus cho input khi component re-render
  useEffect(() => {
    if (inputRef.current && document.activeElement !== inputRef.current) {
      inputRef.current.focus();
    }
  }, [newLessonTitle]);

  return (
    <div className="bg-white p-8 rounded-3xl shadow-2xl border border-gray-200">
      <div className="flex items-center mb-6">
        <input
          ref={inputRef}
          type="text"
          value={newLessonTitle}
          onChange={(e) => setNewLessonTitle(e.target.value)}
          placeholder="Nhập tên bài học mới..."
          className="flex-grow text-lg p-4 rounded-l-xl border-2 border-r-0 bg-white border-gray-300 text-gray-800 placeholder-gray-500 focus:border-blue-500 focus:ring-blue-500 focus:outline-none transition-colors"
        />
        <button
          onClick={onAddLesson}
          className={`text-lg font-semibold px-8 py-4 rounded-r-xl bg-red-600 hover:bg-red-700 text-white transition-colors`}
        >
          Thêm bài học
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {lessons.map((lesson) => (
          <div
            key={lesson.id}
            className={`relative group p-6 rounded-2xl shadow-lg cursor-pointer transform hover:scale-105 transition-transform duration-300 bg-gray-800/70 hover:bg-gray-700/90`}
            onClick={() => onSelectLesson(lesson)}
          >
            <h2 className="text-2xl font-bold text-white mb-2">{lesson.title}</h2>
            <p className="text-white opacity-80">{lesson.phrases?.length || 0} cụm từ</p>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDeleteLesson(lesson.id);
              }}
              className="absolute top-3 right-3 bg-white bg-opacity-20 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity"
              aria-label="Xóa bài học"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LessonList;
